import React, { createContext, useContext } from 'react';

import type { LuminaInteractionHandler } from './interaction';

const LuminaInteractionContext = createContext<LuminaInteractionHandler | undefined>(undefined);

type LuminaInteractionProviderProps = {
	children: React.ReactNode;
	onInteraction?: LuminaInteractionHandler;
};

export const LuminaInteractionProvider = ({
	children,
	onInteraction,
}: LuminaInteractionProviderProps): React.JSX.Element => (
	<LuminaInteractionContext.Provider value={onInteraction}>
		{children}
	</LuminaInteractionContext.Provider>
);

export const useLuminaInteraction = (): LuminaInteractionHandler | undefined =>
	useContext(LuminaInteractionContext);
